export const ua = {
  activate: 'Активувати',
  newsletter: {
    title: 'Приєднуйтеся до спільноти Renew та отримайте знижку 10% на перше замовлення',
    text: 'Будьте серед перших, хто дізнається про новинки та спеціальні пропозиції.',
    placeholder: 'Введіть свою електронну адресу',
    subscribe: 'Підписатися',
    success: 'Будь ласка, перевірте свою електронну пошту та підтвердьте підписку.',
    emailError: 'Перевірте правильність введеної електронної адреси.'
  }
};
